import ReducerUtils            from "../../../utils/ReducerUtils"
import Actions                 from "../../../model/constant/actions"


const TryingPush = ReducerUtils.createReducer(false,{
  [Actions.TRYING_NEW_PACY_CONFIGS_ACTION] : (state,action) => action.status
})

export default TryingPush
